module.exports = __webpack_public_path__ + "img/e9.1ea20407.jpg";